import axios from 'axios';
import Pagination from 'components/pagination/pagination';
import { createLoader, removeLoader } from 'helpers/loader/loader';
import scrollToElement from 'helpers/scroll/scrollTo';
import addToCartAjax from 'components/add-to-cart/addToCartAjax';

export default (function () {
    const init = function () {
        const boughtTogetherEl = document.querySelector('#bought-together-products-container');

        if (boughtTogetherEl) {
            _findShopButtons(boughtTogetherEl);

            const boughtTogetherPaginationEl = document.querySelector('#bought-together-pagination');
            let paginationAdded = false;
            /*-----------------------------Create pagination------------------------------*/
            const createBoughtTogetherPagination = function (pages) {
                //Create pagination
                const boughtTogetherPagination = new Pagination({
                    selector: '#bought-together-pagination',
                    totalPages: parseInt(pages)
                });

                boughtTogetherPagination.create();

                //load new page function
                const loadNewPage = function () {
                    loadBoughtTogetherProducts(); //Load next page
                    scrollToElement('#bought-together-products-container'); //Scroll to top of element
                };

                //Add eventlistener
                boughtTogetherPaginationEl.addEventListener('click', loadNewPage);
                //Set keydown event for accesibillity
                boughtTogetherPaginationEl.addEventListener('keydown', function (e) {
                    if (e.keyCode === 13) {
                        // keycode 13 is enter/return key
                        loadNewPage(e);
                    }
                });

                paginationAdded = true; //Set pagination added to true
            };

            /*-----------------------------Load Bought Together Products------------------------------*/
            const loadBoughtTogetherProducts = function () {
                const page = boughtTogetherPaginationEl.getAttribute('data-page');
                createLoader(boughtTogetherEl);
                axios
                    .get(boughtTogetherEl.getAttribute('data-url') + page + '?parent=product')
                    .then((response) => {
                        boughtTogetherEl.innerHTML = response.data.html; //Add html to page
                        _findShopButtons(boughtTogetherEl);
                        removeLoader(boughtTogetherEl); //Remove loader
                        //If there is not pagination added yet. Add pagination
                        if (!paginationAdded) {
                            createBoughtTogetherPagination(response.data.totalPages); //Create the pagination
                            boughtTogetherPaginationEl.classList.remove('d-none'); //Show pagination element
                        }
                    })
                    .catch(() => {
                        boughtTogetherEl.parentElement.style.display = 'none'; //Hide bought together elment
                        removeLoader(boughtTogetherEl); //Remove loader
                    });
            };

            createBoughtTogetherPagination(boughtTogetherEl.getAttribute('data-totalpages'));
            boughtTogetherPaginationEl.classList.remove('d-none');
        }

        //DEV-111 START: Can be removed after completion of AB test 111.
        const boughtTogetherElV2 = document.querySelector('#bought-together-products-containerV2');

        if (boughtTogetherElV2) {
            _findShopButtons(boughtTogetherElV2);

            const boughtTogetherPaginationElV2 = document.querySelector('#bought-together-paginationV2');
            let paginationAdded = false;
            /*-----------------------------Create pagination------------------------------*/
            const createBoughtTogetherPagination = function (pages) {
                //Create pagination
                const boughtTogetherPagination = new Pagination({
                    selector: '#bought-together-paginationV2',
                    totalPages: parseInt(pages)
                });

                boughtTogetherPagination.create();

                //load new page function
                const loadNewPage = function () {
                    loadBoughtTogetherProducts(); //Load next page
                    scrollToElement('#bought-together-products-containerV2'); //Scroll to top of element
                };

                //Add eventlistener
                boughtTogetherPaginationElV2.addEventListener('click', loadNewPage);
                //Set keydown event for accesibillity
                boughtTogetherPaginationElV2.addEventListener('keydown', function (e) {
                    if (e.keyCode === 13) {
                        // keycode 13 is enter/return key
                        loadNewPage(e);
                    }
                });

                paginationAdded = true; //Set pagination added to true
            };

            /*-----------------------------Load Bought Together Products------------------------------*/
            const loadBoughtTogetherProducts = function () {
                const page = boughtTogetherPaginationElV2.getAttribute('data-page');
                createLoader(boughtTogetherElV2);
                axios
                    .get(boughtTogetherElV2.getAttribute('data-url') + page + '?parent=product')
                    .then((response) => {
                        boughtTogetherElV2.innerHTML = response.data.html; //Add html to page
                        _findShopButtons(boughtTogetherElV2);
                        removeLoader(boughtTogetherElV2); //Remove loader
                        //If there is not pagination added yet. Add pagination
                        if (!paginationAdded) {
                            createBoughtTogetherPagination(response.data.totalPages); //Create the pagination
                            boughtTogetherPaginationElV2.classList.remove('d-none'); //Show pagination element
                        }
                    })
                    .catch(() => {
                        boughtTogetherElV2.parentElement.style.display = 'none'; //Hide bought together elment
                        removeLoader(boughtTogetherElV2); //Remove loader
                    });
            };

            createBoughtTogetherPagination(boughtTogetherElV2.getAttribute('data-totalpages'));
            boughtTogetherPaginationElV2.classList.remove('d-none');
        }
    };
    //DEV-111 END: AB test 111.

    const _findShopButtons = (parent) => {
        const btns = parent.querySelectorAll('[data-shopbtn]');
        btns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const el = e.target.closest('[data-shopbtn]');
                const id = el.dataset.shopbtnId;
                const url = el.dataset.shopbtnUrl;
                const reload = el.dataset.shopbtnReloadpage;
                const qty = el.dataset.quantity;

                addToCartAjax(btn, id, url, reload, false, qty);
            });
        });
    };
    /*-----------------------------Public methods------------------------------*/
    return {
        init: init
    };
})();
